import {
  Channel,
  ChannelType,
  postCloneOrUpdateAgent,
  postCreateChannel,
  postCreateUser,
  Role,
  UserType,
} from '@nemuru-eng/js-api-client';
import { v4 as uuidv4 } from 'uuid';

import { AddNewAdminType } from '@/components/modules/Users/schemas/addNewAdmin.schema';
import { AddNewAgentType } from '@/components/modules/Users/schemas/addNewAgent.schema';
import { UserCredentialsType } from '@/components/modules/Users/types/UserCredentials';
import { CreateChannelType } from '@/components/shared/components/CreateChannelDialog/schema/CreateChannelSchema';
import { REVALIDATE_USERS_LIST_ID } from '@/components/shared/components/UserList/UserList';
import { useUserContext } from '@/contexts/UserContext/UserContext';
import { useRequest } from '@/hooks/requests/useRequest';
import { useUser } from '@/hooks/useUser';

export const useUserCredentials = () => {
  const { userEntity } = useUserContext();
  const { request } = useRequest();
  const { revalidateStructure } = useUser();

  const revalidateStructureAndUsers = async () => {
    await revalidateStructure();
    const button = document.getElementById(REVALIDATE_USERS_LIST_ID);
    await button?.click();
  };

  type SendRequestByActionType = {
    action: UserCredentialsType;
    formValues: AddNewAgentType | CreateChannelType | AddNewAdminType;
    selectedChannel?: Channel;
  };

  const sendRequestByActionType = async ({ action, formValues, selectedChannel }: SendRequestByActionType) => {
    if (action === UserCredentialsType.AGENT && selectedChannel && 'email' in formValues) {
      await request(postCloneOrUpdateAgent, {
        agentId: uuidv4(),
        clonedAgentId: selectedChannel.agents[0].id,
        agentName: formValues.username as string,
        agentEmail: formValues.email as string,
        channelId: selectedChannel.id,
        options: {
          configuration: true,
          agentIdInLenderContext: true,
          pricings: true,
          user: {
            create: true,
            sendPasswordRecovery: true,
          },
        },
      });
    }
    if (action === UserCredentialsType.CHANNEL && userEntity?.merchant?.id && 'description' in formValues) {
      {
        await request(postCreateChannel, {
          id: uuidv4(),
          description: formValues.description as string,
          type: formValues.type as ChannelType,
          merchantId: userEntity?.merchant?.id,
        });
      }
    }
    if (action === UserCredentialsType.ADMIN && selectedChannel && 'username' && 'password' in formValues) {
      await request(postCreateUser, {
        id: uuidv4(),
        userId: selectedChannel.id,
        userType: UserType.CHANNEL,
        roles: [Role.ROLE_CHANNEL],
        userName: formValues.username as string,
        password: formValues.password as string,
        active: true,
      });
    }
  };
  return {
    sendRequestByActionType,
    revalidateStructureAndUsers,
  };
};
